import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const defaultUser = {
  id: null,
  name: null,
  lastName: null,
  role: null,
  email: null,
};

const userStore = create(
  persist(
    (set, get) => ({
      // Auth state
      token: null,
      user: defaultUser,
      setToken: token => {
        localStorage.setItem('token', token);
        set({ token });
      },
      setUser: user => set({ user }),
      updateUser: user => {
        set(state => ({ user: { ...state.user, ...user } }));
      },

      // Sidebar state
      sidebarOpen: false,
      setSidebarOpen: open => set({ sidebarOpen: open }),
      sidebarExpanded: false,
      setSidebarExpanded: expanded => set({ sidebarExpanded: expanded }),

      // Task count state
      taskCount: 0,
      setTaskCount: taskCount => set({ taskCount }),

      // Operators state
      operators: [],
      setOperators: operators => set({ operators }),
      updateOperators: operators => set(state => ({ operators: [...state.operators, ...operators] })),

      logout: () => {
        localStorage.removeItem('token');
        set(state => ({ token: null, user: defaultUser, operators: [], taskCount: 0 }));
      },
    }),
    {
      name: 'claimup-store',
    }
  )
);

export default userStore;
